import marquee from "vanilla-marquee";

document.addEventListener('DOMContentLoaded', () => {
  if ( ! document.getElementById('js-marquee')) {
    return;
  }

  new marquee(document.getElementById('js-marquee'), {
    speed: 100
  });
});

//480px以下のスマホ時だけ、高さを動的に適用
function setResponsiveHeight() {
  var div = document.getElementById('slide');
  if (window.innerWidth <= 480) {
    // div.style.height = (div.clientWidth * 0.59 + 22) + 'px';
  } else {
    // div.style.height = '';
  }
}

// 初期設定
setResponsiveHeight();

// ウィンドウリサイズ時にも適用
window.addEventListener('resize', setResponsiveHeight);

//slickスライドの設定
const heroSlider = new Splide('.pageHeroSlide', {
  type        : 'loop',
  autoplay    : true,
  interval    : 3000,
  arrows      : false,
  pagination  : true,
  padding     : '0px',
  focus       : 'center', // アクティブなスライドを中央に配置
  autoWidth   : true,     // CSSの width: 600px を活かす設定
  trimSpace   : false,    // 両端に余白（隙間）を作らずループさせる
  breakpoints : {
    481: {
      autoWidth: false, // スマホでは false
    }
  }
}).mount();